import { connect } from 'react-redux'
import { compose } from 'recompose'
import gql from 'graphql-tag'

import {
  makesPaginatedQueries,
  pageAndDataFetched,
  resetList,
  fetchPageStart,
  fetchPageError,
} from 'data/graphql'

import { getListState } from 'data'

import { noteAttrsForListsWithGoodSidebarFragment } from 'remote/notes'

const listNoteChildrenNotesQuery = gql`
  query listNoteChildrenNotes($noteId: ID!, $pagination: PaginationInput!) {
    showNote(noteId: $noteId) {
      notes(
        pagination: $pagination
        order: { field: listPosition, direction: DESC }
      ) {
        totalCount
        edges {
          cursor
          node {
            ...noteAttrsForLists
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
  ${noteAttrsForListsWithGoodSidebarFragment}
`

export const getListName = ({ noteId }) => `note-${noteId}-children-notes`

const fetchesChannelNotes = ({ itemsPerPage = 40 } = {}) =>
  compose(
    connect(
      (state, ownProps) => {
        const noteId = ownProps.noteId

        const listName = getListName({
          noteId,
        })
        const listState = getListState(listName)(state)
        return {
          listName,
          listState,
          noteId,
        }
      },
      {
        pageAndDataFetched,
        resetList,
        fetchPageStart,
        fetchPageError,
      }
    ),
    makesPaginatedQueries({
      resetOnUnmount: true,
      query: listNoteChildrenNotesQuery,
      shouldReset(props, nextProps) {
        return props.listName !== nextProps.listName
      },
      getVariables: ({ listState, noteId }) => ({ options }) => {
        const endCursor =
          listState && !options.startFresh ? listState.pageInfo.endCursor : null
        return {
          noteId,
          pagination: {
            first: itemsPerPage,
            after: endCursor,
          },
        }
      },
      getOnReset: ({ resetList, listName }) => () => resetList(listName),
      getOnFetchStart: ({ fetchPageStart, listName }) => ({ options, meta }) =>
        fetchPageStart(listName, meta.variables, options),
      getOnFetchSuccess: ({ pageAndDataFetched, listName }) => ({
        result,
        options,
      }) => {
        const connection = result.data.showNote.notes
        pageAndDataFetched(listName, connection, options)
      },
      getOnFetchError: ({ fetchPageError, listName }) => error =>
        fetchPageError(listName, error),
    })
  )

export default fetchesChannelNotes
